import { getToken, getUserId,getConfig } from '@/utils/auth';
import md5 from 'crypto-js/md5';

//加密平台标识
const OS = 'web';

//加密盐
const SALT = 'emhhHaC';

//获取请求头
export const getHeader = () => {
    const timeStamp = Date.now() + '';
    const sign = '01' + md5(timeStamp + SALT);
    let obj = {
        'os': OS,
        'x-time': timeStamp,
        'x-sign': sign,
    };
    if (getToken()) {
        obj['token'] = getToken();
    }
    if (getUserId()) {
        obj['userId'] = getUserId();
    }
    return obj;
}

//上传图片地址
export const uploadUrl = 'https://api.zhgylgl.com/api/uploadImg';

//获取公共数据列表
export const publicList = () => {
    let globalInfo = getConfig();
    if (!globalInfo) return {};
    let carLong, carType, goodsType, unit; //目前用到四个公共数据 车长 车型 货物类型 货物单位

    carType = globalInfo.carType;
    unit = globalInfo.unit;
    goodsType = globalInfo.goodsType.map(item => ({
        name: item,
        key: item
    }));
    carLong = globalInfo.carLong.map(item => ({
        name: item,
        key: item
    }));

    return {
        carLong,
        carType,
        goodsType,
        unit,
        validityPeriodTime: globalInfo.validityPeriodTime
    };
}


//车辆类型
export const carTypes = [
    '轻型自卸货车',
    '重型仓栅式半挂车',
    '重型仓栅式货车',
    '重型厢式货车',
    '重型平板自卸货车',
    '重型特殊结构货车',
    '重型自卸半挂车',
    '重型自卸货车',
    '重型半挂牵引车',
]

//省份列表
export const citys = [
    "北京市",
    "天津市",
    "上海市",
    "重庆市",
    "河北省",
    "山西省",
    "辽宁省",
    "吉林省",
    "黑龙江省",
    "江苏省",
    "浙江省",
    "安徽省",
    "福建省",
    "江西省",
    "山东省",
    "河南省",
    "湖北省",
    "湖南省",
    "广东省",
    "海南省",
    "四川省",
    "贵州省",
    "云南省",
    "陕西省",
    "甘肃省",
    "青海省",
    "内蒙古自治区",
    "广西壮族自治区",
    "西藏自治区",
    "宁夏回族自治区",
    "新疆维吾尔自治区",
    // "台湾省",
    // "香港特别行政区",
    // "澳门特别行政区"
]


//深克隆方法
export const deepClone = (obj) => {
    let objClone = Array.isArray(obj) ? [] : {};
    if (obj && typeof obj === "object") {
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                //判断ojb子元素是否为对象，如果是，递归复制
                if (obj[key] && typeof obj[key] === "object") {
                    objClone[key] = deepClone(obj[key]);
                } else {
                    //如果不是，简单复制
                    objClone[key] = obj[key];
                }
            }
        }
    }
    return objClone;
}

//获取唯一值
export const getUUid = (obj) => {
    return Math.random().toString(32).slice(2, 8);
}